export const DEFAULT_STYLES = {
  buttonColor: '#00BF6F',
  buttonTextColor: '#FFFFFF',
  secondaryButtonColor: '#FFFFFF',
  secondaryButtonTextColor: '#00BF6F',
  badgeColor: '#00BF6F',
  badgeTextColor: '#FFFFFF',
  iconColor: '#00BF6F',
  containerBackgroundColor: '#FFFFFF',
  inputBackgroundColor: '#f3f2f1',
  inputBorderColor: 'transparent',
  inputBorderHoverColor: 'transparent',
  inputBorderFocusColor: 'transparent',
};

export const DEFAULT_CREATE_WIZARD_CONFIG = {
  redirectToEditorPage: false,
  redirectTo: 'poll',
  readOnlySurvey: false,
  showCreatePollCard: true,
  showCreateSurveyCard: false,
  showStartFromTemplateCard: false,
  showCreateQuizCard: false,
  primaryCtaCopy: 'Create poll',
  secondaryCtaCopy: '',
  showPrimaryCtaIcon: false,
  parentDomain: '*',
  questionConfig: [
    {
      forTypes: ['single_choice', 'dropdown'],
      maxOptions: 10,
      customConfigs: [
        {
          id: 'comments',
          label: 'Allow comments',
        },
      ],
      hideRequired: true,
    },
  ],
  style: DEFAULT_STYLES,
  survey: {},
  templatesList: [],
};

export default DEFAULT_CREATE_WIZARD_CONFIG;
